<template>
  <div class="site-search-job-card__container">
    <a v-if="result" :href="computed_link" @click="save_search">
      
      <div class="site-search-job-card">
        <div class="site-search-job-card__wrapper">

          <div class="site-search-job-card__logo-container">
            <img class="site-search-job-card__logo" :src="$filters.analyseImage(result['org-logo'],'logosm','logoxl')" width="54" height="54" :alt="result['org-name']" loading="lazy">
          </div>

          <div class="site-search-job-card__body">
            <div class="site-search-job-card__body-start">
              <h3 class="site-search-job-card__title"><a :href="computed_link">{{ result['job-title'] }}</a></h3>
            </div>
            <div class="site-search-job-card__body-end">
              <p v-if="result['location-txt']"><span>in</span> {{ result['location-txt'] }}</p>
              <p v-if="result['option-term']" class="site-search-job-card__body-end-term">{{ result['option-term'] }}</p>
            </div>
          </div>

          <svg-chevron-left></svg-chevron-left>
          
        </div>
      </div>

    </a>
 </div>
</template>

<script>
export default {
  props: {
    result: {
      type: Object,
      default: {}
    }
  },

  data() {
    return {

    }
  },

	mounted() {
		//	console.log('site search job', this.result);
	},

  methods: {
		save_search() {
			this.$emit('save:search');
		}
  },

  computed: {
		computed_link() {
			if (this.result['slug'] !== null && this.result['slug'] !== '') {
				return `/opportunity/${this.result['slug']}`;
			}
			if (this.result['id'] !== null && this.result['id'] !== '') {
				return `/opportunity/redirect/${this.result['id']}`
			}
			return '#';
		}
  }
}
</script>

